type TToIndividualNormalized = { employeeId: string; _id: string };
type TToIndividualIncoming = {
	employeeId?: string;
	_id?: string;
	employee?: { employeeId?: string; _id?: string };
};

interface IEmailDistributionItem {
	toIndividuals: TToIndividualIncoming[];
}

const normalizeToIndividuals = (items: TToIndividualIncoming[] = []): TToIndividualNormalized[] => {
	return (items ?? [])
		.map((item) => {
			const employeeId = String(item?.employeeId ?? item?.employee?.employeeId ?? "").trim();
			const rawId = item?._id ?? item?.employee?._id ?? item?.employeeId;
			const _id = String(rawId ?? "").trim();
			return { employeeId, _id };
		})
		.filter((item) => Boolean(item.employeeId));
};

const formatEmailDistribution = <T extends IEmailDistributionItem>(
	emailDistribution: T[]
): Array<Omit<T, "toIndividuals"> & { toIndividuals: TToIndividualNormalized[] }> => {
	return (emailDistribution ?? []).map((distribution) => {
		return {
			...distribution,
			toIndividuals: normalizeToIndividuals(distribution.toIndividuals),
		};
	});
};

export default formatEmailDistribution;
